import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@solarwindscloud/nighthawk-ui';

const SubmitButton = props => {
  return (
    <Button
      type="submit"
      disabled={props.disabled}
      loading={props.loading}
      primary
      data-test-login-button // Used by Tasman tests
      floated="right"
      data-test-id="submit-button"
    >
      {props.children}
    </Button>
  );
};

SubmitButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};
SubmitButton.displayName = 'SubmitButton';

export default SubmitButton;
